import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { Button, Modal, ModalBody } from "reactstrap";
import ataEncaminhamentosService from "services/AtaEncaminhamentosService";
import { Check, SignOut } from "@phosphor-icons/react";

const ModalFinish = ({ show, onCloseClick, data }) => {
	const clickFinish = async () => {
		try {
			await ataEncaminhamentosService.put(data.id, { status: "OK" });
		} catch (error) {
			console.log(error);
		}
		onCloseClick();
	};

	return (
		<Modal
			size="sm"
			isOpen={show}
			toggle={onCloseClick}
			centered={true}
			style={{ minWidth: 700 }}
			zIndex={1500}
		>
			<div className="modal-content">
				<ModalBody className="px-4 py-5 text-center">
					<p className="text-muted font-size-16">
						Você tem certeza que deseja mudar o status para OK?
					</p>
					<p className="text-muted font-size-16 fw-bold flex">
						{data?.description}
					</p>

					<div className="hstack gap-2 justify-content-center mb-0">
						<Button
							type="button"
							style={{
								background: "none",
								padding: 10,
								cursor: "pointer",
								color: "black",
								display: "flex",
								alignItems: "center",
								justifyContent: "center",
								gap: 2,
							}}
							onClick={clickFinish}
						>
							<Check size={16} /> OK
						</Button>
						<Button
							type="button"
							style={{
								background: "none",
								padding: 10,
								cursor: "pointer",
								color: "black",
								display: "flex",
								alignItems: "center",
								justifyContent: "center",
								gap: 2,
							}}
							onClick={onCloseClick}
						>
							<SignOut size={16} /> Fechar
						</Button>
					</div>
				</ModalBody>
			</div>
		</Modal>
	);
};

ModalFinish.propTypes = {
	show: PropTypes.bool,
	onCloseClick: PropTypes.func,
	data: PropTypes.any,
};

export default ModalFinish;
